import axios from '../axios'

const ACTIONS = {
    GET_INFO_TEAM_PUBLIC_SUCCESS: 'GET_INFO_TEAM_PUBLIC_SUCCESS',
    GET_INFO_TEAM_PUBLIC_ERROR: 'GET_INFO_TEAM_PUBLIC_ERROR'
};

const getTeamPublic = (params) => {
    return async () => {
        const {data} = await axios.get(`api/teams/${params.team_id}/notices`, {
            params: params,
        });
        return data;
    };
};

export {
    ACTIONS, getTeamPublic,
};